import { Box, Typography, Tooltip } from '@mui/material';
import theme from '@shared/themes/darkTheme';
import { CARD_WIDTH_VALUES } from '../constants';

interface GridCardProps {
  title: string;
  imagePath?: string;
  imageUrl?: string;
  isAvailable?: boolean;
  onClick: () => void;
  duration?: number;
  publishedAt?: string;
  showComingSoon?: boolean;
  selected?: boolean;
  sx?: any;
  height?: string;
  minWidth?: string;
}

export const GridCard = ({
  title,
  imagePath,
  imageUrl,
  isAvailable = true,
  onClick,
  duration,
  publishedAt,
  showComingSoon = false,
  selected = false,
  sx,
  height = '280px',
  minWidth = '215px',
}: GridCardProps) => {
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.showCardBackground,
        borderRadius: '12px',
        overflow: 'hidden',
        cursor: isAvailable ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        height: height,
        width: CARD_WIDTH_VALUES,
        minWidth: minWidth,
        display: 'flex',
        flexDirection: 'column',
        border: `${selected ? `1px solid ${theme.palette.primary.main}` : 'none'}`,
        opacity: isAvailable ? 1 : 0.7,
        '&:hover': isAvailable
          ? {
              transform: 'translateY(-4px)',
            }
          : {},
        ...sx,
      }}
      onClick={() => {
        if (isAvailable) {
          onClick();
        }
      }}
    >
      <Box
        sx={{
          height: '200px',
          position: 'relative',
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        <img
          src={imageUrl || `/assets/news-thumbnails/${imagePath}`}
          alt={title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center',
          }}
          loading="lazy"
          onError={e => {
            e.currentTarget.src = '/assets/news-thumbnails/thumb_generic_flux_news.png';
          }}
        />
        {duration !== undefined && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              backgroundColor: theme.palette.background.darker,
              borderRadius: '4px',
              px: 1,
              py: 0.5,
            }}
          >
            <Typography variant="caption" color={theme.palette.text.primary}>
              {Math.floor(duration / 60)}:{(duration % 60).toString().padStart(2, '0')}
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          p: 2,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: showComingSoon ? 'center' : 'space-between',
        }}
      >
        <Tooltip title={title} arrow placement="top">
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              mb: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              textAlign: showComingSoon ? 'center' : 'left',
            }}
          >
            {title}
          </Typography>
        </Tooltip>
        {publishedAt && (
          <Typography
            variant="body2"
            color={theme.palette.text.secondary}
            sx={{
              fontSize: '14px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {new Date(publishedAt).toLocaleDateString()}
          </Typography>
        )}
        {showComingSoon && (
          <Typography
            variant="caption"
            sx={{
              textAlign: 'center',
              color: theme.palette.text.secondary,
              fontStyle: 'italic',
            }}
          >
            Coming Soon
          </Typography>
        )}
      </Box>
    </Box>
  );
};
